/* AbNoor — product page: option pickers, variant resolution, photo swap. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.abnoorReady === '1') return;
    root.dataset.abnoorReady = '1';

    var raw = root.querySelector('[data-pdp="variants"]');
    if (!raw) return;
    var variants = [];
    try { variants = JSON.parse(raw.textContent); } catch (e) { return; }
    if (!variants.length) return;

    var form = root.querySelector('[data-pdp-form]');
    var idField = root.querySelector('[data-pdp="variantid"]');
    var cta = root.querySelector('[data-pdp="cta"]');
    var errEl = root.querySelector('[data-pdp="error"]');
    var ctaLabel = root.querySelector('[data-pdp="ctalabel"]');
    var priceEl = root.querySelector('[data-pdp="price"]');
    var noteEl = root.querySelector('[data-pdp="pricenote"]');
    var shownIn = root.querySelector('[data-pdp="shownin"]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-opt]'));
    var imgs = Array.prototype.slice.call(root.querySelectorAll('.abnoor-pdp__img'));
    var baseNote = noteEl ? noteEl.textContent : '';

    /* current selection, one entry per option, null until chosen */
    var chosen = groups.map(function (g) {
      var on = g.querySelector('[data-pdp-val].is-on');
      var vals = g.querySelectorAll('[data-pdp-val]');
      if (on) return on.dataset.value;
      return vals.length === 1 ? vals[0].dataset.value : null;
    });

    function matches(sel) {
      return variants.filter(function (v) {
        return sel.every(function (s, i) { return s === null || v.opts[i] === s; });
      });
    }

    function showMedia(id) {
      if (!id || !imgs.length) return false;
      var hit = imgs.filter(function (im) { return String(im.dataset.mediaId) === String(id); })[0];
      if (!hit) return false;
      imgs.forEach(function (im) { im.classList.toggle('is-on', im === hit); });
      return true;
    }

    var stories = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-stone]'));
    var storyFallback = root.querySelector('[data-pdp-stone-fallback]');

    function colourIndex() {
      var ci = -1;
      groups.forEach(function (g, i) {
        var n = (g.dataset.optName || '').toLowerCase();
        if (ci < 0 && (n.indexOf('colour') > -1 || n.indexOf('color') > -1 || n.indexOf('stone') > -1)) ci = i;
      });
      return ci;
    }

    function paintStory() {
      if (!stories.length) return;
      var ci = colourIndex();
      var want = ci > -1 && chosen[ci] ? String(chosen[ci]).toLowerCase().trim() : null;
      var shown = false;
      stories.forEach(function (el) {
        var on = want !== null && el.dataset.pdpStone === want;
        el.hidden = !on;
        if (on) shown = true;
      });
      if (storyFallback) storyFallback.hidden = shown;
    }

    function setCta(label, disabled, added) {
      if (ctaLabel) ctaLabel.textContent = label;
      if (!cta) return;
      cta.disabled = !!disabled;
      cta.classList.toggle('is-added', !!added);
    }

    function paintAvailability() {
      groups.forEach(function (g, gi) {
        g.querySelectorAll('[data-pdp-val]').forEach(function (b) {
          var probe = chosen.slice();
          probe[gi] = b.dataset.value;
          var any = matches(probe).length > 0;
          b.classList.toggle('is-off', !any);
          b.classList.toggle('is-on', chosen[gi] === b.dataset.value);
        });
        var out = g.querySelector('[data-pdp="optvalue"]');
        if (out) out.textContent = chosen[gi] || 'Choose one';
      });
    }

    function resolve() {
      paintAvailability();
      paintStory();

      var pending = -1;
      chosen.forEach(function (c, i) { if (pending < 0 && c === null) pending = i; });
      if (pending > -1) {
        var name = (groups[pending].dataset.optName || 'option').toLowerCase();
        if (idField) idField.value = '';
        setCta('Choose a ' + name, true, false);
        return;
      }

      var hit = matches(chosen)[0];
      if (!hit) { if (idField) idField.value = ''; setCta('Unavailable', true, false); return; }

      if (idField) idField.value = hit.id;
      if (priceEl && hit.price) priceEl.textContent = hit.price;
      if (noteEl) noteEl.textContent = '';
      if (hit.media) {
        var swapped = showMedia(hit.media);
        if (shownIn && swapped) {
          var ci = colourIndex();
          shownIn.textContent = ci > -1 ? 'Shown in ' + chosen[ci] : '';
        }
      }
      setCta('Add to bag' + (hit.price ? ' — ' + hit.price : ''), false, false);
    }

    groups.forEach(function (g, gi) {
      g.addEventListener('click', function (e) {
        var b = e.target.closest('[data-pdp-val]');
        if (!b || !g.contains(b)) return;
        e.preventDefault();
        chosen[gi] = b.dataset.value;
        resolve();
      });
    });

    /* Accordion rich text: Shopify's editor has no headings, so a paragraph
       written as "Name — description" gets its lead-in promoted to a gold
       label. Works whether or not the author bolded or capitalised it. */
    root.querySelectorAll('.abnoor-pdp__accrte p').forEach(function (p) {
      if (p.querySelector('.abnoor-pdp__rtelabel')) return;
      var first = p.firstChild;
      if (!first || first.nodeType !== 3) return;
      var m = first.nodeValue.match(/^\s*([^—–:]{2,28}?)\s*[—–:]\s*/);
      if (!m) return;
      // A sentence like "Not sure which? Contact us — …" is a call to action,
      // not a heading: leave it as text so "Contact us" can become a link.
      if (/\?|contact|whatsapp|message us|write to us|ask us/i.test(m[1])) return;
      var label = document.createElement('strong');
      label.className = 'abnoor-pdp__rtelabel';
      label.textContent = m[1].trim();
      first.nodeValue = first.nodeValue.slice(m[0].length);
      p.insertBefore(label, first);
    });

    /* Gallery browsing — arrows, dots and thumbnails step through every photo,
       independently of the variant swap. */
    (function () {
      var stage = root.querySelector('[data-pdp="stage"]');
      if (!stage) return;
      var shots = Array.prototype.slice.call(root.querySelectorAll('.abnoor-pdp__img'));
      var pips = Array.prototype.slice.call(root.querySelectorAll('[data-pdp="pip"]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp="thumb"]'));
      if (shots.length < 2) return;

      function show(n) {
        var at = (n + shots.length) % shots.length;
        shots.forEach(function (im, i) { im.classList.toggle('is-on', i === at); });
        pips.forEach(function (p, i) { p.classList.toggle('is-on', i === at); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-on', i === at); });
      }
      function current() {
        for (var i = 0; i < shots.length; i++) if (shots[i].classList.contains('is-on')) return i;
        return 0;
      }
      var prev = root.querySelector('[data-pdp="imgprev"]');
      var next = root.querySelector('[data-pdp="imgnext"]');
      if (prev) prev.addEventListener('click', function () { show(current() - 1); });
      if (next) next.addEventListener('click', function () { show(current() + 1); });
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    })();

    /* "Contact us" typed as plain text in any panel becomes a real link to
       the Help link setting (or the contact page), since the panel editor
       can't reliably add links itself. */
    (function () {
      var href = root.getAttribute('data-help-link') || '/pages/contact';
      var ext = /^https?:|wa\.me|whatsapp/i.test(href);
      var RX = /\b(contact us|whatsapp us|message us|write to us|ask us on whatsapp|ask us)\b/i;
      root.querySelectorAll('.abnoor-pdp__accrte').forEach(function (box) {
        var walker = document.createTreeWalker(box, NodeFilter.SHOW_TEXT, null);
        var hits = [], n;
        while ((n = walker.nextNode())) {
          if (n.parentNode && n.parentNode.closest && n.parentNode.closest('a')) continue;
          if (RX.test(n.nodeValue)) hits.push(n);
        }
        hits.forEach(function (node) {
          var m = node.nodeValue.match(RX);
          if (!m) return;
          var after = node.splitText(m.index);
          after.splitText(m[0].length);
          var a = document.createElement('a');
          a.href = href;
          if (ext) { a.target = '_blank'; a.rel = 'noopener'; }
          a.textContent = after.nodeValue;
          after.parentNode.replaceChild(a, after);
        });
      });
    })();

    var metalBtn = root.querySelector('[data-pdp="metalbtn"]');
    if (metalBtn) {
      metalBtn.addEventListener('click', function () {
        /* Opens the named accordion panel rather than repeating its copy.
           Falls back to any materials/finish panel, then the first panel, so a
           renamed panel never leaves the link dead. */
        var want = (metalBtn.getAttribute('data-panel') || '').trim().toLowerCase();
        var heads = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-acc]'));
        if (!heads.length) return;

        function label(h) {
          return (h.textContent || '').replace(/[+\u2212-]+\s*$/, '').replace(/\s+/g, ' ').trim().toLowerCase();
        }
        var head = null;
        if (want) {
          head = heads.filter(function (h) { return label(h) === want; })[0] || null;
        }
        if (!head) {
          head = heads.filter(function (h) { return /material|metal|finish/.test(label(h)); })[0] || null;
        }
        if (!head) head = heads[0];

        var body = head.nextElementSibling;
        if (body && body.hidden) head.click();

        /* Scroll the nearest scrollable ancestor, not just the window — themes
           sometimes put the page in a scrolling wrapper. Repeat once after the
           panel has expanded, since opening it moves everything below. */
        function scroller() {
          var el = head.parentElement;
          while (el && el !== document.body) {
            var oy = getComputedStyle(el).overflowY;
            if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 4) return el;
            el = el.parentElement;
          }
          return null;
        }
        function go() {
          var box = scroller();
          if (box) {
            var top = head.getBoundingClientRect().top - box.getBoundingClientRect().top + box.scrollTop - 20;
            box.scrollTo ? box.scrollTo({ top: top, behavior: 'smooth' }) : (box.scrollTop = top);
          } else {
            var y = head.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0) - 90;
            window.scrollTo({ top: y, behavior: 'smooth' });
          }
        }
        go();
        setTimeout(go, 320);
      });
    }

    var guideBtn = root.querySelector('[data-pdp="guidebtn"]');
    var guide = root.querySelector('[data-pdp="guide"]');
    if (guideBtn && guide) {
      guideBtn.addEventListener('click', function () {
        var open = !guide.hidden;
        guide.hidden = open;
        guideBtn.textContent = open ? 'Size guide' : 'Hide guide';
      });
    }

    root.querySelectorAll('[data-pdp-acc]').forEach(function (head) {
      var body = head.nextElementSibling;
      if (!body) return;
      head.addEventListener('click', function () {
        var open = head.getAttribute('aria-expanded') === 'true';
        head.setAttribute('aria-expanded', open ? 'false' : 'true');
        body.hidden = open;
        var icon = head.querySelector('i');
        if (icon) icon.textContent = open ? '+' : '\u2212';
      });
    });

    /* Ajax add so the customer stays on the page */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (!idField || !idField.value) return;
        e.preventDefault();
        setCta('Adding\u2026', true, false);
        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        /* Never fall back to a native form post — Shopify answers an out-of-stock
           add with its own error page, which loses the customer. Show why instead. */
        function showError(why) {
          console.warn('[abnoor] cart/add refused:', why);
          var msg = String(why || '').replace(/\s+/g, ' ').trim();
          if (/sold out|not enough|unavailable|out of stock/i.test(msg)) msg = 'Sold out \u2014 write to us to order this piece';
          else if (!msg || /^HTTP/.test(msg)) msg = 'Could not add \u2014 try again';
          setCta(msg.slice(0, 64), false, false);
          if (errEl) { errEl.textContent = String(why).slice(0, 200); errEl.hidden = false; }
        }
        fetch(rootUrl.replace(/\/$/, '') + '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idField.value), quantity: 1 }] })
        }).then(function (res) {
          if (!res.ok) {
            return res.json().catch(function () { return {}; }).then(function (body) {
              showError(body.description || body.message || ('HTTP ' + res.status));
            });
          }
          if (errEl) errEl.hidden = true;
          setCta('Added to bag', false, true);
          return res.json().catch(function () { return null; }).then(function (body) {
            var item = body && (body.items ? body.items[0] : body);
            if (item && item.key) showAdded(item);
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
            setTimeout(resolve, 1800);
          });
        }).catch(function (err) { showError(err); });
      });
    }

    /* ---- "Added" confirmation with Undo ---------------------------------
       Shows exactly what went in, so a wrong size or metal is caught here
       rather than at checkout. Undo takes back only the one piece just
       added — any earlier quantity of the same line stays in the bag. */
    var added = root.querySelector('[data-pdp="added"]');
    var addedHead = root.querySelector('[data-pdp="addedhead"]');
    var addedDetail = root.querySelector('[data-pdp="addeddetail"]');
    var addedImg = root.querySelector('[data-pdp="addedimg"]');
    var undoBtn = root.querySelector('[data-pdp="undo"]');
    var lastLine = null, hideT = null;

    function money(cents) {
      var n = Math.round((Number(cents) || 0) / 100);
      return '\u20B9' + n.toLocaleString('en-IN');
    }
    function hideAdded(delay) {
      clearTimeout(hideT);
      hideT = setTimeout(function () { if (added) added.hidden = true; }, delay);
    }
    function showAdded(item) {
      if (!added) return;
      lastLine = { key: item.key, quantity: item.quantity };
      var opts = (item.options_with_values || []).map(function (o) { return o.value; });
      if (!opts.length && item.variant_title) opts = String(item.variant_title).split(' / ');
      var bits = opts.slice();
      if (item.final_price != null) bits.push(money(item.final_price));
      if (addedDetail) addedDetail.textContent = bits.join(' \u00B7 ');
      if (addedHead) { addedHead.textContent = 'Added to your bag'; addedHead.classList.remove('is-undone'); }
      if (addedImg) {
        var src = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
        addedImg.style.backgroundImage = src ? "url('" + src + "')" : 'none';
        addedImg.classList.remove('is-undone');
      }
      if (undoBtn) { undoBtn.hidden = false; undoBtn.disabled = false; }
      added.hidden = false;
      hideAdded(9000);
    }
    if (undoBtn) {
      undoBtn.addEventListener('click', function () {
        if (!lastLine) return;
        undoBtn.disabled = true;
        var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(rootUrl.replace(/\/$/, '') + '/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: lastLine.key, quantity: Math.max(0, lastLine.quantity - 1) })
        }).then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          lastLine = null;
          undoBtn.hidden = true;
          if (addedHead) { addedHead.textContent = 'Removed from your bag'; addedHead.classList.add('is-undone'); }
          if (addedImg) addedImg.classList.add('is-undone');
          resolve();
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true }));
          hideAdded(3500);
        }).catch(function () {
          undoBtn.disabled = false;
          if (addedHead) addedHead.textContent = 'Could not undo \u2014 remove it in the bag';
        });
      });
    }
    // Changing any option means the card no longer describes the selection.
    root.addEventListener('change', function (e) {
      if (added && !added.hidden && e.target && e.target.type === 'radio') hideAdded(0);
    });

    if (noteEl && baseNote) noteEl.textContent = baseNote;
    resolve();
  }

  function boot() {
    document.querySelectorAll('[data-abnoor-pdp]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
